module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_6.770a4eef.png";